import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { API } from "../../../network/API";
import { authStore } from "../../../stores/AuthStore";
import { generalStore } from "../../../stores/GeneralStore";
import { useQuery } from "../../hooks/useQuery";
import { Routes } from "../router/Routes";
import { pushRoute } from "../router/history";

export const AuthGoogleSite = observer(() => {
    const {
        code,
        state,
        error
    }: {
        code?: string;
        state?: string;
        error?: string;
    } = useQuery();

    React.useEffect(() => {
        const handleGoogleLogin = async (code: string, state: string) => {
            generalStore.isLoading = true;
            try {
                generalStore.isLoading = true;
                await authStore.googleLogin(code, state);
                if (authStore.error) {
                    if (authStore.error === "NotAllowed") {
                        generalStore.setError(t("error.login_user_deactivated"), authStore.error);
                    } else {
                        generalStore.setError(t("error.login"), authStore.error);
                    }

                    pushRoute(Routes.LOGIN);
                    return;
                }
                const decodedCredential = await API.getUserInfo();

                authStore.pictureUrl = decodedCredential.pictureUrl;
                authStore.givenName = decodedCredential.firstName;

                authStore.refreshAfterLogin();
            } catch (error) {
                generalStore.setError(t("error.login"));

                pushRoute(Routes.LOGIN);
            } finally {
                generalStore.isLoading = false;
            }
        };
        if (error) {
            generalStore.setError(t("error.login"));
            pushRoute(Routes.LOGIN);
        } else if (code && state) {
            handleGoogleLogin(code, state);
        }
    }, [code, error, state]);

    return null;
});
